import carousel from "./../carousel";

const benefitsAnimation = () => {
    const top = document.querySelector(".top"),
        bottom = document.querySelector(".bottom"),
        container = document.querySelector('.js-landing-second-container');
        // elArr = gsap.utils.toArray('.landing-benefits__item');

    let timeline = null,
        controller = null,
        scene = null;

    const initAnimation = () => {
        timeline = new TimelineMax()
            .to('.landing-guarantee__title', 2, {
                opacity: 0,
                ease: Linear.easeNone
            }, 'text')
            .to('.landing-guarantee__icon', 2, {
                opacity: 0,
                delay: .5,
                ease: Linear.easeNone
            }, 'text')
            .to(top, 5, {
                y: '-100%',
                force3D: true,
                delay: .1,
                ease: Linear.easeNone
            }, 'point')
            .to(bottom, 5, {
                y: '100%',
                force3D: true,
                delay: .1,
                ease: Linear.easeNone,
            }, 'point');
        // elArr.forEach((el,i) => {
        //     timeline.to(el, 5, {
        //         y: '0',
        //         opacity: 1,
        //         ease: Power3.easeOut,
        //     }, ">" );
        // })


        controller = new ScrollMagic.Controller();

        // build scene
        scene = new ScrollMagic.Scene({
            triggerElement: container,
            triggerHook: "onLeave",
            duration: "100%"
        })
            .setPin(container)
            .setTween(timeline)
            .addTo(controller);
    }

    if ($(window).width() > 1024) {
        initAnimation();
    } else {
        carousel('.js-landing-benefits-slider');
    }


    $(window).on('resize', function () {
        if ($(window).width() > 1024) {
            if(controller === null) {
                initAnimation();
            }
        } else {
            if(controller !== null) {
                controller.destroy(true);
                controller = null;
                scene.destroy(true);

                elArr.forEach((el, i) => {
                    TweenMax.set(el, {clearProps: "all"});
                })
                timeline.clear();

                carousel('.js-landing-benefits-slider');
            }
        }
    });

}
export default benefitsAnimation;